import { post } from "axios"
import store from '../../../store'
// 企业信息
const getCompanyInfo = async (data)=>{
    const res =  await post("index.php?act=store_info&op=store_info",{
        ...data
    })
    return res
}

// 企业信息编辑
const getRedact = async (data)=>{
    return await post("index.php?act=store_info&op=store_info_edit",{
        ...data
    })
    
}
// 退款原因列表
const getReasonList = async (data)=>{
    const res =  await post("index.php?act=store_refund&op=refund_reasonList",{
        ...data
    })
    return res
    
}
// 提交退款申请
const addRefund = async (data)=>{
    const res =  await post("index.php?act=store_refund&op=add_refund",{
        ...data
    })
    return res
    
}
// 退款订单详情
const getRefundOrdersInfo = async (data)=>{
    const res =  await post("index.php?act=store_refund&op=refundOrdersInfo",{
        ...data
    })
    return res
    
}
// 绑定手机号
const bindPhone = async (data) =>{
    const res = await post("index.php?act=login&op=BindingPhone",{
        ...data
    })
}


// 获取账号信息
const getAccMsg = async (data)=>{
    let res = await post("index.php?act=store_info&op=account_info",{
       ...data
    })
    return res
}
// 修改员工账号信息 
const editAccInfo = async (data)=>{
    let res = await post("index.php?act=login&op=update_account",{
        ...data
    })
    return res
}
// 修改员工账号和密码
const editStaffPass = async (data) =>{
    let res = await post("index.php?act=login&op=staff_password_edit",{
        ...data
    })
    return res
}
// 修改密码
const editPass = async (data)=>{
    let res = await post("index.php?act=login&op=password_edit",{
        ...data
    })
    return res
}

// 发布需求
const pubDemand = async (data)=>{
    let res = await post("index.php?act=store_demand&op=demandSave",{
        ...data
    })
    return res
}
const editDemand = async (data)=>{
    let res = await post("index.php?act=store_demand&op=demandEdit",{
        ...data
    })
    return res
}
const getDemandList = async (data)=>{
    let res = await post("index.php?act=web_index&op=demand_list",{
        ...data
    })
    return res
}
// 删除需求
const delDemand = async (data)=>{
    let res = await post("index.php?act=store_demand&op=demand_del",{
        ...data
    })
    return res
}
// 查看需求详情
const getDemandInfo = async (data)=>{
    let res = await post("index.php?act=store_demand&op=demand_info",{
        ...data
    })
    return res
}
// 回复
const verifyDemadn = async (data)=>{
    let res = await post("index.php?act=store_demand&op=demand_verify",{
        ...data
    })
}
// 需求详情
// const getDemandInfo = async (data)=>{
//     let res = await post("index.php?act=store_demand&op=demand_info",{
//         ...data
//     })
// }

// 我的消息
const getMessage= async (data)=>{
    let res = await post("index.php?act=message&op=messageList",{
        ...data
    })
    return res
}
//删除活动信息
const delMessage= async (data)=>{
    let res = await post("index.php?act=message&op=messageDel",{
        ...data
    })
    return res
}
// 物流消息
const wlMessage= async (data)=>{
    let res = await post("index.php?act=message&op=wlMessageList",{
        ...data
    })
    return res
}
//删除物流信息
const delWlMessage= async (data)=>{
    let res = await post("index.php?act=message&op=wlMessageDel",{
        ...data
    })
    return res
}
// 获取未读消息 
const getUnreadMessage= async (data)=>{
    let res = await post("index.php?act=message&op=news",{
        member_id:store.state.member_id,
        ...data
    })
    return res
}

// 更新消息回执
const updateMessage = async (data)=>{
    // data的三个参数
    //   type:"poster", // demand表示需求，poster表示海报
    //    remarks:"1", // 1表示商家已读，2表示用户已读
    //    id:"16" // 消息id
    // let res = 1
    console.log("data",data);
    
    let res = await post("index.php?act=message&op=upnews",data)
    return res
}
// 微信消息相关
// 固定的微信id 表示哪个机器人的 
let gewe_wxid = "wx_OZT2QF6bAFOrORXtg9W6w"
// let gewe_wxid = "wx__F8Zwnruhs8blnOxFTjhw" // 华诺车架号机器人
// 获取群聊分组
const getGroupList= async (data)=>{
    let res = await post("index.php?act=group&op=categoryList",{
        ...data,
        gewe_wxid
    })
    return res
}

// 新增/编辑分组
// id name sort 分组id 分组名称 分组排序
const saveGroup= async (data)=>{
    let res = await post("index.php?act=group&op=saveCategory",{
        ...data,
        gewe_wxid
    })
    return res
}

// 删除子分组
// id 分组id
const delGroup= async (data)=>{
    let res = await post("index.php?act=group&op=deleteCategory",{
        ...data,
        gewe_wxid
    })
    return res
}
// 根据分组id获取群聊id列表 可传空就是获取全部已设置分组的群聊
// category_id 分组id
const getRoomList= async (data)=>{
    let res = await post("index.php?act=group&op=roomList",{
        ...data,
        gewe_wxid
    })
    return res
}
// 批量更新分组

// category_id 分组id
// room_id 群聊id,隔开
// 一个群对一个分组版
const updateRoomCategory= async (data)=>{
    let res = await post("index.php?act=group&op=updateRoomCategory",{
        ...data,
        gewe_wxid
    })
    return res
}
// 批量更新分组  多对多版 覆盖版
// [
//   {
//     "room_id": "wx1",
//     "category_id": 1,
//     "gewe_wxid": "xxxx"
//   },
//   {
//     "room_id": "wx2",
//     "category_id": 2,
//     "gewe_wxid": "xxxx"
//   }
// ]
const batchUpdateCategory= async (data)=>{
    if(!data || data.length === 0){
        return {
            code:400,
            msg:"请选择群聊或分组"
        }
    }else{
        data.forEach(item => {
            item.gewe_wxid = gewe_wxid
        })
    }
    let res = await post("index.php?act=group&op=batchUpdateCategory",data,{
        isJson:true
    })
    return res
}

// 非覆盖版

const insertRoomCategoryBatch= async (data)=>{

    if(!data || data.length === 0){
        return {
            code:400,
            msg:"请选择群聊或分组"
        }
    }else{
        data.forEach(item => {
            item.gewe_wxid = gewe_wxid
        })
    }
    let res = await post("index.php?act=group&op=insertRoomCategoryBatch",data,{
        isJson:true
    })
    return res
}
const batchInsertRoom= async (data)=>{
    let res = await post("index.php?act=group&op=batchInsertRoom",{
        ...data,
        gewe_wxid
    })
    return res
}
// 删除子组中的群聊
// id 群聊记录id
const deleteGroupRoomById= async (data)=>{
    let res = await post("index.php?act=group&op=deleteGroupRoomById",{
        ...data,
        gewe_wxid
    })
    return res
}



// 父分组逻辑
// 获取父分组与子分组列表
// 返回示例
// [
//  ],
const getParentCategoryList= async (data)=>{
    let res = await post("index.php?act=group&op=parentCategoryList",{
        ...data,
        gewe_wxid
    })
    return res
}
// name 分组名称
const saveParentCategory= async (data)=>{
    let res = await post("index.php?act=group&op=saveParentCategory",{
        ...data,
        gewe_wxid
    })
    return res
}
// 删除父分组
// id 父分组id
const deleteParentCategory= async (data)=>{
    let res = await post("index.php?act=group&op=deleteParentCategory",{
        ...data,
        gewe_wxid
    })
    return res
}
// 新增/编辑子分组
// parent_id 父分组id name 子分组名称 
const saveSubCategory= async (data)=>{
    let res = await post("index.php?act=group&op=saveSubCategory",{
        ...data,
        gewe_wxid
    })
    return res
}
// 获取子分组
// parent_id 父分组id
const getChildrenByParent= async (data)=>{
    let res = await post("index.php?act=group&op=getChildrenByParent",{
        ...data,
        gewe_wxid
    })
    return res
}
// 保存发送消息记录
// msg_type	新品发布  消息类型
// text_content	新产品上市啦	消息文字内容
// image_content	“http://example.com/img1.jpg,http://example.com/img2.jpg“	  图片内容
// file_content	“http://example.com/file.pdf,http://example.com/file2.pdf”	  文件内容
// ext_data	[{“msg_id”:”123456”}]	  扩展数据

// store_id	1	
// store_name	华诺威公司	
// member_id	1001	
// member_name	张三	
const sendWxMsg= async (data)=>{
    const res =  await post("index.php?act=message_record&op=add",{
        ...data,
        store_id:store.state.store_id,
        store_name:store.state.store_name,
        member_id:store.state.member_id,
        member_name:store.state.member_name
    })
    return res
    
}
// 更新发送消息记录
// id 消息记录id
const updateWxMsg= async (data)=>{
    const res =  await post("index.php?act=message_record&op=update",{
        ...data,
        store_id:store.state.store_id,
        member_id:store.state.member_id,
        member_name:store.state.member_name
    })
    return res
}
// msg_type	新品发布	是	string	无
// limit	10	是	string	条数
// page	1	是	string	页数
const getWxMsgList= async (data)=>{
    const res =  await post("index.php?act=message_record&op=list",{
        ...data,
        store_id:store.state.store_id
    })
    return res
    
}
// 获取微信消息类型列表
const getWxMsgTypeList= async (data)=>{
    const res =  await post("index.php?act=message_type&op=list",{
        store_id:store.state.store_id,
       
    })
    return res
    
}
// 查询联系人
const queryContacts = async (data)=>{
    

    return await post("index.php?act=contact&op=queryContacts",{
        ...data,
        appId:gewe_wxid
    })
}
// 同步联系人
const syncContacts = async (data)=>{
    return await post("index.php?act=contact&op=syncContacts",{
        
        appId:gewe_wxid
    })
}
// 新增/编辑消息类型
// id name sort 消息类型id 消息类型名称 消息类型排序
const saveMsgType= async (data)=>{
    let res = await post("index.php?act=message_type&op=add",{
        ...data,
        store_id:store.state.store_id,
    })
    return res
}


// 发票
const getInvoList = async ()=>{
    return await post("index.php?act=invoice&op=invoiceList",{
        member_id:store.state.member_id,
        store_id:store.state.store_id,
    })
}
const addInvo = async (data)=>{
    return await post("index.php?act=invoice&op=invoiceAdd",{
        member_id:store.state.member_id,
        store_id:store.state.store_id,
        ...data
    })
}

const editInvo = async (data)=>{
    return await post("index.php?act=invoice&op=invoiceEdit",{
        member_id:store.state.member_id,
        store_id:store.state.store_id,
        ...data
    })
}
const delInvo = async (inv_id)=>{
    return await post("index.php?act=invoice&op=invoiceDel",{
        inv_id  
    })
}
// 收票地址
const getRessList = async ()=>{
    return await post("index.php?act=address&op=ressList",{
        member_id:store.state.member_id,
        store_id:store.state.store_id,
    })
}
const addRess = async (data)=>{
    return await post("index.php?act=address&op=ressadd",{
        member_id:store.state.member_id,
        store_id:store.state.store_id,
        ...data
    })
}
const editRess = async (data)=>{
    return await post("index.php?act=address&op=ressedit",{
        member_id:store.state.member_id,
        store_id:store.state.store_id,
        ...data
    })
}
const delRess = async (id)=>{
    return await post("index.php?act=address&op=ressdel",{
        id  
    })
}
// 退货相关接口
// 退货搜索配件
const afitSearchsale = async (data)=>{
    return await post("index.php?act=afitsale&op=searchsale",{
        ...data  
    })
}
// 获取商品对应退货列表
const getRecordByReGoodsId = async (data)=>{
    return await post("index.php?act=afitsale&op=listDetails",{
        ...data  
    })
}
// 新增退货/换货配件
const addAfitsale = async (data)=>{
    return await post("index.php?act=afitsale&op=addsale",{
        ...data  
    })
}
// 退换货列表
const getAfitsList = async (data)=>{
    return await post("index.php?act=afitsale&op=list",{
        ...data  
    })
}
// 分仓退换货列表
const getBranchAfitsList = async (data)=>{
    
    return await post("index.php?act=afitsale&op=reslut_list",{
        ...data  
    })
}
// 退货详情
const getAfitsInfo = async (data)=>{
    return await post("index.php?act=afitsale&op=detile",{
        ...data  
    })
}


// 提交退货
const commitRetreat = async (data)=>{
    return await post("index.php?op=retreat&act=orders",{
        ...data  
    })
}
// 获取采购额度
const getPurQuota = async ()=>{
    return await post("index.php?act=orders&op=pay_info",{
        store_id:store.state.store_id
    })
}
// 添加物流
const addAfitsLogi = async (data)=>{
    return await post("index.php?act=afitsale&op=reslut_upload",{
        ...data  
    })
    
}
// 获取商品可退货数量
const getGoodsRenum = async (data)=>{
    return await post("index.php?act=afitsale&op=reslut_number",{
        ...data
    })
}
// 设置表格
const updateReport = async (data)=>{
    return await post("index.php?act=report_center&op=report_update",{
        ...data
    })
}

const getReportList = async (data)=>{
    return await post("index.php?act=report_center&op=report_list",{
        ...data
    })
}
// 新获取报表
const getReportListNew = async (data)=>{
    return await post("index.php?act=report_center_new&op=report_list",{
        ...data
    })
}
// 获取新闻
const getNewsList = async (data)=>{
    return await post("index.php?act=message&op=getArticle",{
        ...data
    })
}
// 发布或者修改新闻 如果带上新闻id就是修改新闻
const insertArticle = async (data)=>{
    return await post("index.php?act=message&op=insertArticle",{
        member_id:store.state.member_id,
        member_name:store.state.member_name,
        store_id:store.state.store_id,
        store_name:store.state.store_name,
        ...data
    })
}
// 删除新闻
const delArticle = async (data)=>{
    return await post("index.php?act=message&op=delArticle",{
        ...data
    })
}
// 设置新闻字段
const setArticleField = async (data)=>{
    return await post("index.php?act=message&op=setArticleField",{
        ...data
    })
}

export {
    getRessList,
    addRess,
    editRess,
    delRess,
    getCompanyInfo,
    getRedact,
    bindPhone,
    getAccMsg,
    editAccInfo,
    editPass,
    editStaffPass,
    pubDemand,
    editDemand,
    delDemand,
    getDemandInfo,
    getDemandList,
    verifyDemadn,
    getMessage,
    delMessage,
    // 微信消息相关
    getGroupList,
    saveGroup,
    delGroup,
    getRoomList,
    updateRoomCategory,
    batchUpdateCategory,
    insertRoomCategoryBatch,
    deleteGroupRoomById,
    batchInsertRoom,
    getParentCategoryList,
    saveParentCategory,
    saveSubCategory,
    deleteParentCategory,
    getChildrenByParent,
    sendWxMsg,
    updateWxMsg,
    getWxMsgList,
    getWxMsgTypeList,
    queryContacts,
    syncContacts,
    saveMsgType,
    getInvoList,
    addInvo,
    editInvo,
    delInvo,
    wlMessage,
    delWlMessage,
    getUnreadMessage,
    updateMessage,
    getReasonList,
    addRefund,
    getRefundOrdersInfo,
    afitSearchsale,
    getRecordByReGoodsId,
    addAfitsale,
    getAfitsList,
    getBranchAfitsList,
    getAfitsInfo,
    addAfitsLogi,
    commitRetreat,
    getPurQuota,
    updateReport,
    getReportList,
    getReportListNew,
    getGoodsRenum,
    insertArticle,
    delArticle,
    setArticleField,
    getNewsList
}
